<template>
  <div>
    <v-tabs v-model="activeTab" align-with-title>
      <v-tabs-slider color="accent"></v-tabs-slider>
      <v-tab>CRON JOBS</v-tab>
      <v-tab>BROWSE FILES</v-tab>
      <v-tab>TR WORK FILE EXPORTS</v-tab>
      <v-tab-item>
        <dynamicCronJobs />
      </v-tab-item>
      <v-tab-item>
        <overnightReportsBrowser />
      </v-tab-item>
      <v-tab-item>
        <trWorkFileExportCron />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import dynamicCronJobs from '../../components/import/dynamicCronJobs.vue';
import overnightReportsBrowser from '../../components/import/OvernightReportsBrowser.vue';
import trWorkFileExportCron from '../../components/import/TrWorkFileExportCron.vue';

export default {
  name: 'CronJobs',
  components: {
    dynamicCronJobs,
    overnightReportsBrowser,
    trWorkFileExportCron,
  },
  data() {
    // Tab 0 (legacy CRON JOBS) was merged into the dynamic tab. Remap old
    // deep links: 0/1 -> 0 (merged), 2 -> 1 (Browse), 3 -> 2 (TR Work File).
    const raw = parseInt(this.$route.query.tab, 10);
    const tabRemap = {
      0: 0, 1: 0, 2: 1, 3: 2,
    };
    const mapped = tabRemap[raw];
    return {
      activeTab: mapped === undefined ? 0 : mapped,
    };
  },
  watch: {
    activeTab(val) {
      this.$router.replace({ query: { tab: val } }).catch(() => {});
    },
  },
};
</script>
